import PrescribedDaysCreateForm from './PrescribedDaysCreateForm';

export default PrescribedDaysCreateForm;
